<template>
  <nav class="navbar is-primary">
    <div class="container">
      <div class="navbar-brand">
        <router-link
          to="/"
          class="navbar-item"
        >
          <img src="../../assets/serget2.png">
          <span
            class="is-size-5"
            style="padding-left:20px"
          >Consulta Publica</span>
        </router-link>
        <div
          class="navbar-burger "
          :class="{ 'is-active': openBurger }"
          data-target="navMenu"
          @click="toggleMenu"
        >
          <span />
          <span />
          <span />
        </div>
      </div>
      <div
        id="navMenu"
        class="navbar-menu"
        :class="{ 'is-active': openBurger }"
      >
        <div class="navbar-end">
          <router-link
            to="/"
            class="navbar-item"
          >
            <b-icon icon="magnify" />
            <span class="margin-left">Consulta de Infração</span>
          </router-link>
          <!-- <router-link
            class="navbar-item"
            to="/edital"
          >
            <b-icon icon="folder" />
            <span class="margin-left">Editais</span>
          </router-link> -->
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">
              <b-icon icon="file-document" />
              <span class="margin-left">Formulários</span>
            </a>
            <div class="navbar-dropdown">
              <a
                class="navbar-item"
                :href="indicacao"
                target="_blank"
              >
                Indicação de Condutor
              </a>
              <a
                class="navbar-item"
                :href="advertencia"
                target="_blank"
              >
                Advertência
              </a>
              <a
                class="navbar-item"
                :href="defesa"
                target="_blank"
              >
                Defesa de Autuação
              </a>
              <a
                class="navbar-item"
                :href="jari"
                target="_blank"
              >
                Jari
              </a>
              <a
                class="navbar-item"
                :href="cetran"
                target="_blank"
              >
                Cetran
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data () {
    return {
      openBurger: false
    }
  },
  computed: {
    indicacao () {
      return `${process.env.VUE_APP_CLIENTID}/indicacao.pdf`
    },
    advertencia () {
      return `${process.env.VUE_APP_CLIENTID}/advertencia.pdf`
    },
    defesa () {
      return `${process.env.VUE_APP_CLIENTID}/defesa.pdf`
    },
    jari () {
      return `${process.env.VUE_APP_CLIENTID}/jari.pdf`
    },
    cetran () {
      return `${process.env.VUE_APP_CLIENTID}/cetran.pdf`
    }
  },
  methods: {
    toggleMenu () {
      this.openBurger = !this.openBurger
    }
  }
}
</script>
